import Alt from 'alt';
var Flux = new Alt();
export default Flux;